module.exports = __webpack_public_path__ + "media/images/roku/TV2-b4900efabd28d938afa777c5d51a5c75.png";